<template>
  <v-row>
    <div class="d-flex bg-grey-lighten-1">
      <v-col cols="1" style="padding-right: 0px">
        <div class="d-flex flex-column justify-space-between align-center fill-height">
          <span class="status-text">ON</span>
          <span class="status-text">OFF</span>
        </div>
      </v-col>
      <v-col cols="11" style="padding-left: 0px">
        <div class="d-flex align-start switches-wrapper">
          <div v-for="(bit, index) in model" :key="index">
            <v-switch
                :model-value="bit"
                class="rotated-switch"
                color="yellow"
                hide-details
                readonly
            />
            <v-row class="switch-label">
              {{ index + 1 }}
            </v-row>
          </div>
        </div>
      </v-col>
    </div>
  </v-row>
</template>

<script lang="ts" setup>
const model = defineModel<Array<Boolean>>();

</script>

<style scoped>
.switches-wrapper {
  height: 100px; /* oder passend zu deinem Layout */
  overflow: hidden;
  align-items: center;
  padding-top: 15px;
}

.rotated-switch {
  transform: rotate(270deg);
  transform-origin: center;
}

.switch-label {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.status-text {
  font-weight: bold;
  font-size: 1rem;
  text-align: center;
}

</style>